import { DecimalPipe } from '@angular/common';
import { Component, Input, SimpleChanges } from '@angular/core';
import { Helper } from '@piqet-angular/data';
import { reportTitals } from '@piqet-angular/shared';

@Component({
  selector: 'piqet-angular-organiaztion-equivalancy-unit',
  templateUrl: './organiaztion-equivalancy-unit.component.html',
  styleUrls: ['./organiaztion-equivalancy-unit.component.scss'],
})
export class OrganiaztionEquivalancyUnitComponent {
  @Input() spiderChartItemsData: any;
  @Input() isISOReport = false;
  reportResource = reportTitals;
  imagelist = [];
  imagelistForCategory = [];
  interpretedText: any;
  indicatornamelist = [];
  indicatorEquivalancyUnits = [];
  tempArr: any = [];
  x = 5;
  multiplier: number[] = [];
  indicatorunitnamelist: any;

  constructor(private helper: Helper, private decimalPipe: DecimalPipe) {}

  ngOnChanges(changes: SimpleChanges) {
    this.spiderChartItemsData = changes['spiderChartItemsData'].currentValue;
    const projectInterpretation = this.spiderChartItemsData.projectInterpretation;
    this.interpretedText = !!projectInterpretation
      ? projectInterpretation.replace(/\n/g, '<br/>')
      : '';
    if (this.spiderChartItemsData.scenarioListForAnnumImpact.length > 0) {
      this.imagelist = !!this.spiderChartItemsData.scenarioListForAnnumImpact[0]
        .equivalencyImageTable
        ? this.spiderChartItemsData.scenarioListForAnnumImpact[0].equivalencyImageTable.split(';')
        : [];
      this.imagelistForCategory = !!this.spiderChartItemsData.scenarioListForAnnumImpact[0]
        .indicatorImageName
        ? this.spiderChartItemsData.scenarioListForAnnumImpact[0].indicatorImageName.split(';')
        : [];
      this.indicatornamelist = !!this.spiderChartItemsData.scenarioListForAnnumImpact[0].indicators
        ? this.spiderChartItemsData.scenarioListForAnnumImpact[0].indicators.split(';')
        : [];
      this.indicatorEquivalancyUnits = !!this.spiderChartItemsData.scenarioListForAnnumImpact[0]
        .indicatorEquivalancyUnits
        ? this.spiderChartItemsData.scenarioListForAnnumImpact[0].indicatorEquivalancyUnits.split(
            ';'
          )
        : [];
      this.indicatorunitnamelist = !!this.spiderChartItemsData?.scenarioListForAnnumImpact[0]
        .indicatorUnitName
        ? this.spiderChartItemsData.scenarioListForAnnumImpact[0].indicatorUnitName.split(';')
        : [];
      this.multiplier = this.spiderChartItemsData.scenarioListForAnnumImpact[0].multiplier
        .split(';')
        .map(Number);
      this.arrayFunction();
    }
    const array = this.getRange(this.x);
  }

  getMultiPlication(data: any, number: any) {
    const cleanedImpact = parseFloat(data.replace(/,/g, ''));
    const value = cleanedImpact * number;
    return value.toString();
  }

  arrayFunction() {
    for (let i = 0; i < this.spiderChartItemsData.scenarioListForAnnumImpact.length; i++) {
      this.tempArr.push(
        this.spiderChartItemsData.scenarioListForAnnumImpact[i]?.totals?.split(';')
      );
    }
  }

  getRange(x: number): number[] {
    return Array.from({ length: x }, (_, index) => index);
  }
}
